var map = {
	"./aparthotelclub/ic_tag_area.png": 86899,
	"./beachful/ic_tag_area.png": 51726,
	"./castlepedia/ic_tag_area.png": 43826,
	"./cocktayl/ic_tag_area.png": 94951,
	"./ic_tag_area.png": 89444,
	"./luxresortclub/ic_tag_area.png": 19325,
	"./parkful/ic_tag_area.png": 41861,
	"./prefabworld/ic_tag_area.png": 80989,
	"./rooftopclub/ic_tag_area.png": 41961,
	"./spaclub/ic_tag_area.png": 43787,
	"./worldcasino/ic_tag_area.png": 69126,
	"./zoopedia/ic_tag_area.png": 76839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51424;